import React from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { AgendamentoProvider } from './agendamento';
import { AgendaProvider } from './agenda';
import { CategoriaProvider } from './categoria';
import { FormaPagamentoProvider } from './formapagamento';
import { PerfilProvider } from './perfil';
import { MedicoProvider } from './medico';
import { ClinicaProvider } from './clinica';
import { ChatProvider } from './chat';
import { ModeloProvider } from './modelo';
import { NotaFiscalProvider } from './notafiscal';
import { ProcedimentoProvider } from './procedimentos';

const AppProvider: React.FC = ({ children }) => (
  <ToastProvider>
    <ClinicaProvider>
      <AuthProvider>
        <ChatProvider>
          <CategoriaProvider>
            <FormaPagamentoProvider>
              <PerfilProvider>
                <MedicoProvider>
                  <AgendaProvider>
                    <AgendamentoProvider>
                      <NotaFiscalProvider>
                        <ModeloProvider>
                          <ProcedimentoProvider>
                            {children}
                          </ProcedimentoProvider>
                        </ModeloProvider>
                      </NotaFiscalProvider>
                    </AgendamentoProvider>
                  </AgendaProvider>
                </MedicoProvider>
              </PerfilProvider>
            </FormaPagamentoProvider>
          </CategoriaProvider>
        </ChatProvider>
      </AuthProvider>
    </ClinicaProvider>
  </ToastProvider>
);

export default AppProvider;
